import Debug from './_debug';
import $ from 'jquery';

let CustomStyles = {}; 
CustomStyles.themeUrl = $('.site-logo').parent().attr('href'); ; 

CustomStyles.initialize = () => {
  Debug.log('CustomStyles: initialize');
  
  CustomStyles.customizeTitles();
  CustomStyles.customizeTags();
  CustomStyles.articleSocials();
  CustomStyles.customizeButtonsBg();
  CustomStyles.customizeEncadreCenters();
}

CustomStyles.customizeTitles = () => {
  $('h2, h3').not( ".no-custom-underline" ).addClass('custom-underline').append('<img class="custom-underline-img" src="' + CustomStyles.themeUrl + '/wp-content/themes/respifil/dist/images/bg-title.png" />');
}

CustomStyles.customizeButtonsBg = () => {
  $('.btn-custom-bg').append('<img class="tag-custom-bg" src="' + CustomStyles.themeUrl + '/wp-content/themes/respifil/dist/images/btn-custom-bg.png" />');
}

CustomStyles.customizeTags = () => {
  $('.tag').not('.secondary').append('<img class="tag-custom-bg" src="' + CustomStyles.themeUrl + '/wp-content/themes/respifil/dist/images/tag-bg.png" />');
  $('.tag.secondary').append('<img class="tag-custom-bg" src="' + CustomStyles.themeUrl + '/wp-content/themes/respifil/dist/images/tag-bg-secondary.png" />');
}

CustomStyles.articleSocials = () => {
  $('#dpsp-content-bottom').prepend('<img class="custom-bg-top" src="' + CustomStyles.themeUrl + '/wp-content/themes/respifil/dist/images/bg-title.png" />');
  if ($('.dpsp-share-text').length > 0) {
    let text = $('.dpsp-share-text').slice(0).remove();
    $('#dpsp-content-bottom').prepend(text);
  }
  $('#dpsp-content-bottom').append('<img class="custom-bg-bottom" src="' + CustomStyles.themeUrl + '/wp-content/themes/respifil/dist/images/bg-title.png" />');
}

CustomStyles.customizeEncadreCenters = () => {
  $('.centres-detail-template .wp-block-respifil-paragraph-border .paragraph-border-title').prepend('<span class="icon-respifil-enfant-adulte text-primary mr-1"><span/>');
}


export default CustomStyles;